import ky from 'ky';

let base_url = 'https://data.basetre.com';
let token = 'chhH663mXx2r4pono4SqM9nWmmT2Zz5t';
let endpoint = ky.create({
  prefixUrl: base_url + '/',
  headers: {
    'Authorization': 'Bearer ' + token
  }
});

export class api {
  static base_url = base_url;

  static async post_results(answers) {
    let body = {
      "answer": {
        "organization_type": answers.kind,
        "aim": answers.aim,
        ...answers.a
      }
    }
    return await endpoint.post('items/onat4all_answers_v2', {json: body});
  }
}